import React from "react";
import { Outlet } from "react-router-dom";
import AndroidAppUpdateBanner from "../../Components/AndroidAppUpdateBanner/AndroidAppUpdateBanner";
import "./DashboardContentShell.css";

const DashboardContentShell = () => (
  <div className="dashboard_content_shell">
    <AndroidAppUpdateBanner />
    <Outlet />
  </div>
);

export default DashboardContentShell;
